export const BUILDER_QUERY_KEYS = {
  assets: {
    all: () => ['builder', 'assets'] as const,
    list: (filters: Record<string, unknown>) =>
      ['builder', 'assets', 'list', filters] as const,
  },
  assetCategories: {
    all: () => ['builder', 'asset-categories'] as const,
  },
  products: {
    detail: (id: string) => ['builder', 'product', id] as const,
  },
} as const;
